import { render, staticRenderFns } from "./PdrList.vue?vue&type=template&id=5411a1c2&scoped=true&"
import script from "./PdrList.vue?vue&type=script&lang=js&"
export * from "./PdrList.vue?vue&type=script&lang=js&"
import style0 from "./PdrList.vue?vue&type=style&index=0&id=5411a1c2&prod&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411a1c2",
  null
  
)

export default component.exports